import 'pretendard/dist/web/static/pretendard.css';
var Font = /** @class */ (function () {
    function Font() {
    }
    var _a;
    _a = Font;
    Font.fontFamily = "Pretendard, sans-serif";
    Font.letterSpacing = "0rem"; /** 일괄적으로 변경하려면 수정 */
    Font.fontFeatureSettings = "'clig' off, 'liga' off";
    Font.defaultFontSet = {
        fontFamily: _a.fontFamily,
        letterSpacing: _a.letterSpacing,
        fontFeatureSettings: _a.fontFeatureSettings,
    };
    Font.getFontSize = function (size) {
        if (!size)
            return '0.75rem'; /** 12px */
        switch (size) {
            case 'small': return '0.75rem'; /** 12px */
            case 'medium': return '1rem'; /** 16px */
            case 'large': return '1.375rem'; /** 22px */
            default: return '0.75rem';
        }
    };
    return Font;
}());
export default Font;
